import ReloadIcon from "../images/ReloadIcon.mjs";

/**
 * App icon for reload action
 * @see {GlyphIcon}
 * @see {ReloadIcon}
 */
const AppReloadIcon = class extends ReloadIcon {}

export default AppReloadIcon;